import React, { useMemo } from 'react';
import FilterDropdown from './Filter/components/FilterDropdown';
import { translate } from '../services/translate';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
}

export default function MonthDropdown({ setValue, value, zIndex }: Props) {
    const items = useMemo(() => [
        { name: 'january', value: 0 },
        { name: 'february', value: 1 },
        { name: 'march', value: 2 },
        { name: 'april', value: 3 },
        { name: 'may', value: 4 },
        { name: 'june', value: 5 },
        { name: 'july', value: 6 },
        { name: 'august', value: 7 },
        { name: 'september', value: 8 },
        { name: 'october', value: 9 },
        { name: 'november', value: 10 },
        { name: 'december', value: 11 },
    ].map(month => {
        return { label: translate(month.name), value: month.value };
    }), []);

    return (
        <FilterDropdown
            label={translate('month')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
        />
    );
}
